'use client'

import { ImSpinner4 } from 'react-icons/im'
import { VscError } from 'react-icons/vsc'

interface ChartErrorLoadingIndicatorProps {
  data?: unknown
  error?: Error
}

export const ChartErrorLoadingIndicator = ({ data, error }: ChartErrorLoadingIndicatorProps) => {
  return (
    <>
      {!data && (
        <div className="absolute z-[1] left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 transform items-center gap-1.5">
          {error ? (
            <>
              <span>Error retrieving data</span>
              <VscError />
            </>
          ) : (
            <ImSpinner4 className="ml-8 mr-4 h-8 w-8 animate-spinSlow" />
          )}
        </div>
      )}
    </>
  )
}
